<template>
  <div
    style="
      margin: 0 auto 20px;
      min-height: 320px;
      height: 35vh;
      overflow-y: auto;
    "
  >
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
    >
      <el-col
        :lg="7"
        :md="7"
        :sm="7"
        :xl="7"
        :xs="7"
        style="line-height: 28px; text-align: right; margin-right: 10px"
      >
        空间：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-cascader
          :options="spaceTree"
          :disabled="id !== 0"
          @change="spaceChange"
          change-on-select="true"
          clearable
          collapse-tags
          filterable
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px; width: 80%"
          v-model="spaceId"
        >
        </el-cascader>
      </el-col>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
    >
      <el-col
        :lg="7"
        :md="7"
        :sm="7"
        :xl="7"
        :xs="7"
        style="line-height: 28px; text-align: right; margin-right: 10px"
      >
        误告警类型：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-radio-group @change="typeChange" v-model="type" :disabled="id !== 0">
          <!-- <el-radio label="0" style="margin-top: 7px;">主机屏蔽</el-radio> -->
          <el-radio label="1" style="margin-top: 7px">设备误告警</el-radio>
          <el-radio label="2" style="margin-top: 7px">测点误告警</el-radio>
        </el-radio-group>
      </el-col>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
      v-if="type == 0"
    >
      <el-col
        :lg="7"
        :md="7"
        :sm="7"
        :xl="7"
        :xs="7"
        style="line-height: 28px; text-align: right; margin-right: 10px"
      >
        主机：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          :multiple="gatewayMultiple"
          :disabled="id !== 0"
          clearable
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px; width: 80%"
          v-model="gateway"
        >
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.snCode"
            v-for="item in gatewayList"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
      v-if="type != 0"
    >
      <el-col
        :lg="7"
        :md="7"
        :sm="7"
        :xl="7"
        :xs="7"
        style="line-height: 28px; text-align: right; margin-right: 10px"
      >
        设备：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          :multiple="deviceMultiple"
          @change="deviceChange"
          clearable
          :disabled="id !== 0"
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px; width: 80%"
          v-model="device"
        >
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in deviceList"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
      v-if="type != 0 && type != 1"
    >
      <el-col
        :lg="7"
        :md="7"
        :sm="7"
        :xl="7"
        :xs="7"
        style="line-height: 28px; text-align: right; margin-right: 10px"
      >
        测点：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-select
          :multiple="pointMultiple"
          clearable
          :disabled="id !== 0"
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="padding-bottom: 5px; width: 80%"
          v-model="point"
        >
          <el-option
            :key="item.id"
            :label="item.name"
            :value="item.id"
            v-for="item in pointList"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
    >
      <el-col
        :lg="7"
        :md="7"
        :sm="7"
        :xl="7"
        :xs="7"
        style="line-height: 28px; text-align: right; margin-right: 10px"
      >
        是否启用：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <el-radio label="0" style="margin-top: 7px" v-model="isShield"
          >否</el-radio
        >
        <el-radio label="1" style="margin-top: 7px" v-model="isShield"
          >是</el-radio
        >
      </el-col>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
    >
      <el-row>
        <el-col
          :lg="7"
          :md="7"
          :sm="7"
          :xl="7"
          :xs="7"
          style="line-height: 28px; text-align: right; margin-right: 10px"
          >误报时间(秒)：</el-col
        >
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <el-input
            v-model.number="misTime"
            autocomplete="off"
            oninput="value=value.replace(/[^\d]/g, '')"
            size="mini"
            style="width: 160px"
            type="text"
            class="pb-1"
          ></el-input>
          <div
            style="
              font-size: 0.8rem;
              margin-bottom: 5px;
              color: rgb(216, 228, 106);
            "
          >
            * 低于误报时间不会产生告警
          </div>
        </el-col>
      </el-row>
      <el-row style="color: #4aec96; font-size: 0.9rem">
        <el-col :sm="8" :xs="8" style="text-align: right"
          ></el-col
        >
        <el-col :sm="14" :xs="16">
          <!-- {{ falseWarningLimitOfTime.modifyTime }} -->
        </el-col>
      </el-row>
    </el-col>
    <el-col
      :lg="24"
      :md="24"
      :sm="24"
      :xl="24"
      :xs="24"
      style="margin-top: 20px"
    >
      <el-row>
        <el-col
          :lg="7"
          :md="7"
          :sm="7"
          :xl="7"
          :xs="7"
          style="line-height: 28px; text-align: right; margin-right: 10px"
          >误告警次数：</el-col
        >
        <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
          <el-input
            v-model.number="misCount"
            autocomplete="off"
            oninput="value=value.replace(/[^\d]/g, '')"
            size="mini"
            style="width: 160px"
            type="text"
            class="pb-1"
          ></el-input>
          <div
            style="
              font-size: 0.8rem;
              margin-bottom: 5px;
              color: rgb(216, 228, 106);
            "
          >
            * 低于误报次数不会产生告警
          </div>
        </el-col>
      </el-row>
      <el-row style="color: #4aec96; font-size: 0.9rem">
        <el-col :sm="8" :xs="8" style="text-align: right"
          ></el-col
        >
        <el-col :sm="14" :xs="16">
          <!-- {{ falseWarningLimitOfTimes.modifyTime }} -->
        </el-col>
      </el-row>
    </el-col>
    <!-- <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="margin-top: 20px">
      <el-col :lg="7" :md="7" :sm="7" :xl="7" :xs="7" style="line-height: 28px;text-align: right;margin-right: 10px;">
        屏蔽时间：
      </el-col>
      <el-col :lg="15" :md="15" :sm="15" :xl="15" :xs="15">
        <div style="padding-top: 1px">
          <el-checkbox v-model="designatedTime">指定时间</el-checkbox>
        </div>
        <div v-if="designatedTime">
          <div :key="index" v-for="(item,index) in timeList">
            <el-time-picker
              end-placeholder="结束时间"
              format="HH:mm"
              is-range
              placeholder="选择时间范围"
              range-separator="至"
              size="mini"
              start-placeholder="开始时间"
              style="margin-top: 10px;width: 70%"
              v-model="item.value"
              value-format="HH:mm">
            </el-time-picker>
            <el-button @click="addTime" size="mini" style="color: #07E6F8;margin-left: 5px" v-if="index === 0"> +
            </el-button>
            <el-button @click="deleteTime(index)" size="mini" style="color: red;margin-left: 5px;padding: 7px 17px;"
                       v-else>-
            </el-button>
          </div>
        </div>

      </el-col>
    </el-col> -->
  </div>
</template>

<script>
import { gatewayList } from "@/network/device-gateway";
import { userDevice } from "@/network/device-info";
import { listByDeviceId } from "@/network/device-measuring-point";
import lodash from "lodash";
import { findNameById } from "@/utils/common";

export default {
  name: "AlarmMissModify",
  props: ["spaceTree", "form", "id"],
  data() {
    return {
      spaceId: "",
      isShield: "0",
      gateway: "",
      device: "",
      point: "",
      type: "0",
      spaceInfoId: "",
      popHeight: "30vh",
      gatewayList: [],
      deviceList: [],
      pointList: [],
      gatewayMultiple: true,
      deviceMultiple: false,
      pointMultiple: false,
      designatedTime: true,
      // 误告警时间
      misTime: '',
      // 误告警次数
      misCount: '',
    };
  },
  watch: {
    spaceTree(newVal) {
      this.spaceTree = newVal;
      console.log(this.spaceTree, "this.spaceTree");
      this.getDeviceList();
    },
    form(newVal) {
      this.form = newVal;
      this.setForm(lodash.cloneDeep(this.form));
    },
  },
  created() {
    this.getGatewayList();
  },
  mounted() {
    this.setForm(this.form);
  },
  methods: {
    typeChange(newVal) {
      this.gateway = "";
      this.device = "";
      this.point = "";
      this.checkType(newVal);
    },
    checkType(newVal) {
      if (newVal == 0) {
        this.popHeight = "30vh";
        this.gatewayMultiple = true;
        this.pointMultiple = this.deviceMultiple = false;
      }
      if (newVal == 1) {
        this.popHeight = "30vh";
        this.pointMultiple = this.gatewayMultiple = false;
        this.deviceMultiple = true;
      }
      if (newVal == 2) {
        this.popHeight = "40vh";
        this.deviceMultiple = this.gatewayMultiple = false;
        this.pointMultiple = true;
      }
    },
    spaceChange(val) {
      if (val) {
        if (val.length > 0) {
          // 查询空间  若空间为逻辑空间，不允许选中
          this.spaceInfoId = val[val.length - 1];
          this.getDeviceList();
          this.device = "";
          this.point = "";
        }
      }
    },
    deviceChange() {
      if (this.type == 2) {
        this.getPointList();
        this.point = "";
      }
    },
    getGatewayList() {
      gatewayList().then((res) => {
        if (res.data) {
          this.gatewayList = res.data;
        }
      });
    },
    getDeviceList() {
      let spaceInfo = Array.isArray(this.spaceInfoId)
        ? this.spaceInfoId[0]
        : this.spaceInfoId + '';
        console.log(spaceInfo, spaceInfo.length > 0)
      if (spaceInfo.length > 0) {
        userDevice(spaceInfo).then((res) => {
          if (res.data) {
            this.deviceList = res.data;
          }
        });
      }
    },
    getPointList() {
      let device = Array.isArray(this.device) ? this.device[0] : this.device;
      listByDeviceId(device).then((res) => {
        if (res.data) {
          this.pointList = res.data;
        }
      });
    },
    checkForm() {
      if (!this.spaceId) {
        this.$message.error("请选择空间");
        return false;
      }
      if (this.type == 0 && this.gateway.length <= 0) {
        this.$message.error("请选择主机");
        return false;
      }
      if (this.type > 0 && this.device.length <= 0) {
        this.$message.error("请选择设备");
        return false;
      } else if (this.type > 1 && this.point.length <= 0) {
        this.$message.error("请选择测点");
        return false;
      }
      return true;
    },
    setForm(form) {
      if (form.spaceId !== undefined) {
        console.log(form.spaceId, 'form.spaceId')
        this.spaceInfoId = form.spaceId;
        this.type = form.misType + "";
        this.checkType(this.type);
        this.spaceId = form.spaceId;
        this.isShield = form.isEnable ? "1" : "0";
        this.gateway = "";
        this.device = "";
        this.point = "";
        this.gateway = this.type == 0 ? [form.gatewaySn] : form.gatewaySn;
        this.device = this.type == 1 ? [form.deviceId] : form.deviceId;
        this.point = this.type == 2 ? [form.pointId] : form.pointId;
        this.misTime = form.misTime;
        this.misCount = form.misCount;
        // 获取设备
        this.getDeviceList();
        // 获取测点
        if (form.misType > 1) {
          this.getPointList();
        }
        this.$forceUpdate();
      } else {
        this.getDeviceList();
        this.spaceId = "";
        this.isShield = "0";
        this.device = "";
        this.point = "";
        this.type = "0";
        this.misTime = "";
        this.misCount = "";
        this.gateway = "";
        this.spaceInfoId = "";
        this.popHeight = "30vh";
        this.deviceList = [];
        this.pointList = [];
        this.gatewayMultiple = false;
        this.deviceMultiple = false;
        this.pointMultiple = false;
      }
    },
    getForm() {
      let returnForm = [];
      let spaceId = Array.isArray(this.spaceId)
        ? this.spaceId[this.spaceId.length - 1]
        : this.spaceId;
      let spaceName = findNameById(this.spaceTree, spaceId);
      // 校验数据
      if (this.checkForm()) {
        let isEnbale = this.isShield == 1;
        // 组装数据 返回
        if (this.type == 1) {
          if (Array.isArray(this.device)) {
            for (let item of this.device) {
              let deviceName = this.deviceList.filter((i) => i.id ==  item)[0].name;
              let device = this.deviceList.filter((i) => i.id == item)[0];
              let form = {
                isEnable: isEnbale,
                spaceId: spaceId,
                spaceName: spaceName,
                misType: this.type,
                deviceId: item,
                deviceName: deviceName,
                gatewaySn: device.gatewaySn,
                misTime: this.misTime,
                misCount: this.misCount,
                id: this.id === 0 ? null : this.id
              };
              returnForm.push(form);
            }
          } else {
            let device = this.deviceList.filter((i) => i.id == this.device)[0];
            let deviceName = this.deviceList.filter((i) => i.id == this.device)[0].name;
            let form = {
              isEnable: isEnbale,
              spaceId: spaceId,
              spaceName: spaceName,
              misType: this.type,
              deviceId: this.device,
              deviceName: deviceName,
              gatewaySn: device.gatewaySn,
              misTime: this.misTime,
              misCount: this.misCount,
              id: this.id === 0 ? null : this.id
            };
            returnForm.push(form);
          }
          return returnForm;
        } else if (this.type == 2) {
          let device = this.deviceList.filter((i) => i.id == this.device)[0];
          let deviceName = this.deviceList.filter((i) => i.id == this.device)[0].name;
          if (Array.isArray(this.point)) {
            for (let item of this.point) {
              let pointName = this.pointList.filter((i) => i.id == item)[0].name;
              let form = {
                isEnable: isEnbale,
                spaceId: spaceId,
                spaceName: spaceName,
                gatewaySn: device.gatewaySn,
                misType: this.type,
                deviceId: this.device,
                deviceName: deviceName,
                pointId: item,
                pointName: pointName,
                misTime: this.misTime,
                misCount: this.misCount,
                id: this.id === 0 ? null : this.id
              };
              returnForm.push(form);
            }
          } else {
            let pointName = this.pointList.filter((i) => i.id == this.point)[0].name;
            let form = {
              isEnable: isEnbale,
              spaceId: spaceId,
              spaceName: spaceName,
              gatewaySn: device.gatewaySn,
              misType: this.type,
              deviceId: this.device,
              deviceName: deviceName,
              pointId: this.point,
              pointName: pointName,
              misTime: this.misTime,
              misCount: this.misCount,
              id: this.id === 0 ? null : this.id
            };
            returnForm.push(form);
          }
          return returnForm;
        }
      }
    },
  },
};
</script>

<style scoped></style>
